import type { IPublicClientApplication } from '@azure/msal-browser';
import { appConfig } from '../config';
import { markSignedOut } from './session';

/**
 * Signs out of this application, and only of this application. MSAL's logoutRedirect would send the browser to
 * Microsoft's end-session endpoint, signing the person out of every other application in that browser session;
 * dropping the cached tokens is all this application's own sign-out means.
 *
 * The flag goes down before the tokens do: the moment the account disappears the sign-in gate would otherwise
 * ask the still-open Entra session for a new one. Then a full load of the root, which is what actually clears
 * everything the previous session left in memory.
 */
export async function signOutLocally(
  instance: IPublicClientApplication,
  /** Injected for the tests, which have nowhere to navigate to. */
  navigateTo: (url: string) => void = (url) => window.location.assign(url),
): Promise<void> {
  markSignedOut();
  await instance.clearCache();
  navigateTo(appConfig.redirectUri || '/');
}
